import type { Workspace } from '../../types';
import { safeJsonDate } from './date';

export const normalizeWorkspace = (data: Workspace<string>): Workspace | null => {
  if (!data) return null;

  return Object.assign(data, {
    createdOn: safeJsonDate(data.createdOn),
  });
};